import { Grid, CardActionArea } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const ChooseBubbleType = ({ bubble, setBubble }) => {
  const theme = useTheme();

  function handleSelect(type) {
     setBubble(type);
  }

  return (
    <Grid
      container
      sx={{ flexDirection: "row", gap: 4, justifyContent: "space-evenly" }}
    >
      {/* Life Science Card */}
      <Card
        sx={{
          maxWidth: 345,
          bgcolor:
            bubble && bubble === "lifeScience"
              ? "#4D7E70"
              : theme.palette.primary.main,
          padding: 2,
        }}
      >
        <CardActionArea onClick={() => handleSelect("lifeScience")}>
          <CardMedia
            component="img"
            alt="Life Science"
            style={{ objectFit: "contain" }}
            image="https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2Fimage.png?alt=media&token=dfe8c4b1-2783-4156-a1da-ea7adbd3745a" // <-- Replace with your image
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div" color="#FFF">
              Life Science
            </Typography>
            <Typography variant="body2" color="#FFFFFF">
              Ensure Compliance and Quality with End-to-End Traceability
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>

      {/* General Manufacturing Card */}
      <Card
        sx={{
          maxWidth: 345,
          bgcolor:
            bubble && bubble === "generalManufactoring"
              ? "#4D7E70"
              : theme.palette.primary.main,
          padding: 2,
        }}
      >
        <CardActionArea onClick={() => handleSelect("generalManufactoring")}>
          <CardMedia
            component="img"
            alt="General Manufacturing"
            style={{ objectFit: "contain" }}
            image="https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2Fimage.png?alt=media&token=dfe8c4b1-2783-4156-a1da-ea7adbd3745a" // <-- Replace with your image
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div" color="#FFF">
              General Manufacturing
            </Typography>
            <Typography variant="body2" color="#FFFFFF">
             Transform Your Manufacturing Operations with Real-Time Visibility and Control
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default ChooseBubbleType;
